import { useLocation } from "react-router-dom";
import { parseRelativeUrl } from "src/services/url";
import { State } from "../components/Navigation";

export function useNavLinkState(url?: string, matchParams?: string[]): State {
  const location = useLocation();

  if (url === undefined) {
    return "inactive";
  }

  const targetUrl = parseRelativeUrl(url);
  if (matchParams && location.pathname === targetUrl?.pathname) {
    const currentParams = new URLSearchParams(location.search);
    return matchParams.every(
      (param) =>
        (currentParams.get(param) ?? "") ===
        (targetUrl.searchParams.get(param) ?? "")
    )
      ? "active"
      : "inactive";
  }

  return location.pathname === url ? "active" : "inactive";
}
